import { userResource } from "@legacy-megarax/iam-contracts";
import { useResourceProviderV2 } from "@legacy-megarax/react-client";
import { commonErrorsMap, useSnackbarErrorHandler } from "@legacy-megarax/ui-components";

import { Result } from "@megaron/result";

const promisifyResult = <TValue, TError>(result: Result<TValue, TError>): Promise<TValue> =>
  new Promise((resolve, reject) => {
    if (result.isFailure) return reject(result.error);
    resolve(result.value);
  });

export const useUsersResource = () => {
  const usersProvider = useResourceProviderV2(userResource);

  const handleError = useSnackbarErrorHandler({
    ...commonErrorsMap,
  });
  const getUsers = (searchText: string) =>
    usersProvider
      .list({ searchText, limit: 100 })
      .mapError(handleError)
      .map((result) => result.items)
      .then(promisifyResult);

  return {
    getUsers,
  };
};
